import { __assign } from "tslib";
import hexToRgba from 'hex-rgba';
import spcColors from './spcColors';
import paletteLight from './paletteLight';
var black = spcColors.black,
    gray = spcColors.gray,
    negative = spcColors.negative,
    accent = spcColors.accent,
    white = spcColors.white,
    light = spcColors.light;

var limeLightPalette = __assign(__assign({}, paletteLight), {
  background: {
    neutral: {
      primary: '#FFFFFF',
      secondary: '#FAFCFE',
      tertiary: '#F0F4FA',
      popover: '#FFFFFF',
      primaryTransparent: 'rgba(255, 255, 255, 0.56)',
      tertiaryTransparent: 'rgba(240, 244, 250, 0.56)',
      dialogOverlay: 'rgba(27, 39, 64, 0.32)'
    },
    semantic: {
      warning: '#FFF5D6',
      accent: '#EDFCDE',
      positive: '#DCF0E8',
      negative: '#FCE3E3',
      positiveGradient: 'linear-gradient(180deg, #17191C 0%, #142B2B 50.47%, #0F4031 100%)',
      negativeGradient: 'linear-gradient(180deg, #29181A 0%, #3B1A1E 50.99%, #63181A 100%)'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #FFFFFF 3.5%, rgba(255, 255, 255, 0) 96.51%)',
      secondary: 'linear-gradient(180deg, #FAFCFE 3.5%, rgba(250, 252, 254, 0) 96.51%)',
      tertiary: 'linear-gradient(180deg, #F0F4FA 3.5%, rgba(240, 244, 250, 0) 96.51%)'
    }
  },
  label: {
    accent: '#2F8A21',
    accentHigh: '#2F7337',
    accentHighest: '#205C32',
    primary: '#152238',
    secondary: '#788BB0',
    secondaryHigh: '#62769C',
    tertiary: '#95A6C7',
    tertiaryHigh: '#7B90B8',
    placeholder: '#ACB9D4',
    inactive: 'rgba(118, 134, 168, 0.4)',
    positive: '#1B825E',
    negative: '#E83F41',
    warning: '#D49800',
    inverse: '#FFFFFF',
    primaryActive: '#2F8A21',
    secondaryActive: '#62769C',
    tertiaryActive: '#7B90B8',
    plaseholder: '#ACB9D4'
  },
  fill: __assign(__assign({}, paletteLight.fill), {
    primary: {
      highest: '#266E39',
      high: '#35823C',
      mid: '#3B9126',
      low: '#76BD5E',
      muted: '#ABE38F',
      overlay32: 'rgba(110, 212, 42, 0.32)',
      overlay24: 'rgba(127, 214, 41, 0.24)',
      overlay16: 'rgba(133, 219, 46, 0.16)',
      overlay8: 'rgba(112, 217, 0, 0.08)'
    },
    secondary: {
      highest: '#192840',
      high: '#3E5273',
      mid: '#95A6C7',
      low: '#B2C4D6',
      muted: '#D5E1EB',
      overlay32: 'rgba(175, 200, 224, 0.32)',
      overlay24: 'rgba(171, 194, 217, 0.24)',
      overlay16: 'rgba(171, 193, 214, 0.16)',
      overlay8: 'rgba(151, 176, 201, 0.08)'
    }
  }),
  divider: {
    primary: '#E3E7ED',
    secondary: '#E1E7ED',
    tertiary: '#DBE3EB',
    altPrimary: '#E4EAF0',
    altSecondary: '#F3F7FA'
  },
  static: {
    backgroundPrimary: '#182338',
    black: '#0E1726',
    blackAlfa72: 'rgba(14, 23, 38, 0.72)',
    blackAlfa56: 'rgba(14, 23, 38, 0.56)',
    blackAlfa24: 'rgba(14, 23, 38, 0.24)',
    blackAlfa16: 'rgba(14, 23, 38, 0.16)',
    blackAlfa8: 'rgba(14, 23, 38, 0.08)',
    blackAlfa4: 'rgba(14, 23, 38, 0.04)',
    white: '#FFFFFF',
    whiteAlfa72: 'rgba(255, 255, 255, 0.72)',
    whiteAlfa56: 'rgba(255, 255, 255, 0.56)',
    whiteAlfa24: 'rgba(255, 255, 255, 0.24)',
    whiteAlfa16: 'rgba(255, 255, 255, 0.16)',
    whiteAlfa8: 'rgba(255, 255, 255, 0.08)',
    whiteAlfa4: 'rgba(255, 255, 255, 0.04)',
    primary: '#67B859',
    primaryAlfa32: 'rgba(92, 164, 79, 0.32)',
    secondary: '#879DBE',
    secondaryAlfa32: 'rgba(130, 151, 190, 0.32)',
    positive: '#4BBF93',
    negative: '#FF6B6E',
    note: '#FFCB30'
  },
  shadow: {
    button: '0px 1px 3px 0px rgba(92, 164, 79, 0)',
    accent: '0px 3px 6px -2px rgba(92, 164, 79, 0.3), 0px 8px 12px rgba(92, 164, 79, 0.1), 0px 9px 16px rgba(56, 56, 67, 0.11)',
    popover: '0px 4px 16px rgba(46, 60, 86, 0.24), 0px 16px 40px rgba(102, 119, 151, 0.16)',
    dialog: '0px 12px 16px rgba(35, 53, 84, 0.1), 0px 10px 56px rgba(24, 39, 64, 0.38)',
    cardEasy: '0px 6px 16px rgba(120, 123, 156, 0.08)',
    cardHeavy: '0px 1px 4px rgba(110, 158, 218, 0.12), 0px 6px 16px rgba(149, 169, 199, 0.2)',
    headerWeb: '0px 1px 4px rgba(78, 100, 135, 0.16), 0px 6px 16px rgba(118, 148, 186, 0.25)'
  },
  base: {
    accent: accent['1'],
    error: negative['1'],
    disabled: gray['3']
  },
  input: {
    main: {
      text: black['1'],
      background: hexToRgba(gray['1'], 8),
      backgroundDisabled: hexToRgba(gray['1'], 4),
      backgroundHover: hexToRgba(gray['1'], 16),
      backgroundError: hexToRgba(negative['1'], 8),
      border: gray['3'],
      borderDisabled: hexToRgba(gray['3'], 56),
      borderHover: gray['1'],
      borderError: negative['1']
    },
    label: gray['1'],
    message: gray['1']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['1'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(black['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: white['1'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: black['3'],
    secondary: gray['1']
  },
  paper: __assign(__assign({}, paletteLight.paper), {
    background: white['1']
  }),
  modal: {
    backdrop: hexToRgba(black['0'], 32)
  },
  dialog: {
    background: white['1']
  },
  dropDown: {
    background: white['1']
  },
  dividerLegacy: {
    primary: light['4'],
    secondary: light['4']
  },
  switch: {
    icon: white['1'],
    shadow: paletteLight.switch.shadow,
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(gray['1'], 8),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: gray['5'],
    backgroundSecondary: white['2']
  },
  snackbar: {
    text: white['2'],
    background: black['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
});

export default limeLightPalette;